// This function allow to reference async chunks
__webpack_require__.u = function(chunkId) {
	// return url for filenames based on template
	return "static/chunks/" + (chunkId === 6992 ? "be74e82d" : chunkId) + "." + {"3642":"19bf414025c2dbe5","6992":"70a70842e95cdc67"}[chunkId] + ".js";
};